import { NgModule } from '@angular/core';

import { SharedModule }                    from '../../app-lite/shared/shared.module';
import { TransactionColumnComponent }      from './transaction-column.component';
import { TransactionExpandedRowComponent } from './transaction-expanded-row.component';
import { TransactionHeaderComponent }      from './transaction-header.component';
import { TransactionRowComponent }         from './transaction-row.component';

@NgModule({
  declarations: [
    TransactionColumnComponent,
    TransactionExpandedRowComponent,
    TransactionHeaderComponent,
    TransactionRowComponent
  ],
  entryComponents: [
    TransactionColumnComponent,
    TransactionExpandedRowComponent,
    TransactionHeaderComponent,
    TransactionRowComponent
  ],
  imports: [
    SharedModule
  ]
})
export class DashboardModule {}